document.addEventListener("DOMContentLoaded", () => {
  const mobileMenuIcon = document.querySelector(".mobile-icon-custom");
  const closeIcon = document.querySelector(".webvibe_close-custom-icon");
  const headerBlock = document.querySelector(
    ".wp-block-blocks-webvibe-block-header .header-content .wp-block-navigation"
  );
  const mobileSocial = document.querySelector(".mobile-social");
  const mobileMenuLogo = document.querySelector(".mobile-menu-logo");
  const header = document.querySelector("header");
  const backTopBtn = document.querySelector(".wv-back-top-btn");

  const isMenuOpen = () => headerBlock?.classList.contains("active");

  const updateStickyHeader = () => {
    if (!header) return;

    if (isMenuOpen()) {
      header.classList.remove("sticky-on");
    } else {
      header.classList.toggle("sticky-on", window.scrollY > 300);
    }
  };

  const updateBackTopButton = () => {
    if (!backTopBtn) return;

    if (isMenuOpen()) {
      backTopBtn.classList.remove("active");
    } else {
      backTopBtn.classList.toggle("active", window.scrollY > 800);
    }
  };

  const updateUI = () => {
    updateStickyHeader();
    updateBackTopButton();
  };

  if (mobileMenuIcon) {
    mobileMenuIcon.addEventListener("click", () => {
      if (headerBlock) headerBlock.classList.add("active");
      if (closeIcon) closeIcon.classList.add("active-icon");
      if (mobileSocial) mobileSocial.classList.add("active-mobile-social");
      if (mobileMenuLogo) mobileMenuLogo.classList.add("show");

      updateUI();
    });
  }

  if (closeIcon) {
    closeIcon.addEventListener("click", () => {
      if (headerBlock) headerBlock.classList.remove("active");
      closeIcon.classList.remove("active-icon");
      if (mobileSocial) mobileSocial.classList.remove("active-mobile-social");
      if (mobileMenuLogo) mobileMenuLogo.classList.remove("show");

      updateUI();
    });
  }

  let ticking = false;

  window.addEventListener(
    "scroll",
    () => {
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(() => {
        updateUI();
        ticking = false;
      });
    },
    { passive: true }
  );

  if (backTopBtn) {
    backTopBtn.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }

  updateUI();
});